export default __webpack_public_path__ + "static/media/Interactive Map.ee3dd843.svg";